// Libs
import clsx from "clsx";
import React from "react";
import type { RTableProps } from "src/design-system/core/utils";

// Components

export interface TableProps extends React.PropsWithChildren<Omit<RTableProps, "ref">> {
    /**
     * Additional className
     */
    className?: string;
    /**
     * Has full width
     */
    fullWidth?: boolean;
    /**
     * Max height
     */
    maxHeight?: number;
    /**
     * Width
     */
    width?: number;
    /**
     * Has full height
     */
    fullHeight?: boolean;
    /**
     * Additional className for the table container
     */
    tableContainerClassName?: string;
    /**
     * define if the table has a fixed layout (each column has a fixed width if no width is defined in the configuration all column has the same width)
     */
    fixedLayout?: boolean;
}

export const Table = React.forwardRef<HTMLDivElement, TableProps>(function Table(
    {
        children,
        className: classNameProp,
        fullWidth = true,
        fullHeight = false,
        maxHeight,
        width,
        fixedLayout = false,
        tableContainerClassName: tableContainerClassNameProps,
        ...otherProps
    },
    ref
) {
    const className = clsx(
        "ds-c-table",
        {
            "ds-c-table--full-width": fullWidth,
            "ds-c-table--full-height": fullHeight,
        },
        classNameProp
    );

    const tableContainerClassName = clsx(
        "ds-c-table__container",
        {
            "ds-c-table__container--fixed-table-layout": fixedLayout,
            "ds-c-table--full-height": fullHeight,
        },
        tableContainerClassNameProps
    );

    return (
        <div
            className={className}
            style={{
                maxHeight: maxHeight,
                width: width !== undefined ? width : undefined,
            }}
            ref={ref}
        >
            <table className={tableContainerClassName} {...otherProps}>
                {children}
            </table>
        </div>
    );
});
